export default {"src":"/uk/_next/static/media/profileIcon.16b6590a.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};